import { AuthenticatedTemplate } from "@azure/msal-react";
import "./index.scss";
import Hook from "./useTerms";
import { PrimaryButton, SecondaryButton } from "@moneris-portal/button";
import Loader from "@moneris-portal/loader";

function QBO_Terms(params) {
  const { BLOCK, translate, isLoading, isReady, isOmsFlow, acceptContinue, setAcceptContinue, acceptTC, setAcceptTC, isConditionAccepted, handleAccept, handleBack } = Hook.useTerms(params);

  if (!isReady) {
    return <Loader />;
  }

  return (
    <AuthenticatedTemplate>
      <div className={`${BLOCK.current}`}>
        <div className={`${BLOCK.current}__container`}>
          <div className={`${BLOCK.current}__header`}>
            <h1>{translate("terms-header-title")}</h1>
          </div>
          <div className={`${BLOCK.current}__content`}>
            <div className={`${BLOCK.current}__terms-scroll`}>
              <h2>{translate("terms-title")}</h2>
              <h3>{translate("terms-clause-1-title")}</h3>

              <ul className={`${BLOCK.current}__clause-list`}>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-1-item-1") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-1-item-2") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-1-item-3") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-1-item-4") }}></li>
              </ul>

              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-2-title")}
              </h3>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-2-item-1"),
                }}
              />
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-2-item-2"),
                }}
              />
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-2-item-3"),
                }}
              />
              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-3-title")}
              </h3>

              <table className={`${BLOCK.current}__description ${BLOCK.current}__clause-table`}>
                <thead>
                  <tr>
                    <th>{translate("terms-clause-3-header-1")}</th>
                    <th>{translate("terms-clause-3-header-2")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{translate("terms-clause-3-item-1")}</td>
                    <td>{translate("terms-clause-3-item-2")}</td>
                  </tr>
                  <tr>
                    <td>{translate("terms-clause-3-item-3")}</td>
                    <td>{translate("terms-clause-3-item-4")}</td>
                  </tr>
                </tbody>
              </table>
              
              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-4-title")}
              </h3>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-4-description"),
                }}
              />
            
              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-5-title")}
              </h3>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-5-description"),
                }}
              />

              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-6-title")}
              </h3>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-6-item-1"),
                }}
              />
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-6-item-2"),
                }}
              />

              
              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-7-title")}
              </h3>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-7-item-1"),
                }}
              />
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-7-item-2"),
                }}
              />
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-7-item-3"),
                }}
              />

              <h3 className={`${BLOCK.current}__clause-title`}>
                {translate("terms-clause-8-title")}
              </h3>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-8-item-1"),
                }}
              />
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-8-item-2"),
                }}
              />

              <h4 className={`${BLOCK.current}__section-title`}>
                {translate("terms-clause-8-section-1-title")}
              </h4>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-8-section-1-intro"),
                }}
              />
              <ul className={`${BLOCK.current}__clause-list`}>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-1") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-2") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-3") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-4") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-5") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-6") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-7") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-1-8") }}></li>
              </ul>

              <h4 className={`${BLOCK.current}__section-title`}>
                {translate("terms-clause-8-section-2-title")}
              </h4>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-8-section-2-intro"),
                }}
              />
              <ul className={`${BLOCK.current}__clause-list`}>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-2-1") }}></li>
              </ul>
              <p className={`${BLOCK.current}__description`}
                dangerouslySetInnerHTML={{
                  __html: translate("terms-clause-8-item-2-1-note"),
                }}
              />
              <ul className={`${BLOCK.current}__clause-list`}>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-2-2") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-2-3") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-2-4") }}></li>
                <li dangerouslySetInnerHTML={{ __html: translate("terms-clause-8-item-2-5") }}></li>
              </ul>
            </div>
            <div className={`${BLOCK.current}__checkbox-container`}>
              <label className={`${BLOCK.current}__checkbox-label`}>
                <input
                  type="checkbox"
                  checked={acceptContinue}
                  disabled={isLoading}
                  onChange={(e) => setAcceptContinue(e.target.checked)}
                />
                <span>
                  <span dangerouslySetInnerHTML={{ __html: translate("terms-accept-continue-cb") }} />
                  <span className={`${BLOCK.current}__required`}> *</span>
                </span>
              </label>
              <label className={`${BLOCK.current}__checkbox-label`}>
                <input
                  type="checkbox"
                  checked={acceptTC}
                  disabled={isLoading}
                  onChange={(e) => setAcceptTC(e.target.checked)}
                />
                <span>
                  <span dangerouslySetInnerHTML={{ __html: translate("terms-accept-tc-cb") }} />
                  <span className={`${BLOCK.current}__required`}> *</span>
                </span>
              </label>
            </div>
            <div className={`${BLOCK.current}__button-container`}>
              <div className={`${BLOCK.current}__button-spacer`} />
              {!isOmsFlow && (
                <SecondaryButton
                  clickHandler={handleBack}
                  title={translate("terms-go-back")}
                />
              )}
              <PrimaryButton
                isDisabled={isLoading || !isConditionAccepted}
                clickHandler={handleAccept}
                title={
                  isLoading ? (
                    <div
                      className={`${BLOCK.current}__loader-container loader_panel`}
                    >
                      <div className={`${BLOCK.current}__loader spinner`} />
                    </div>
                  ) : (
                    translate("terms-accept")
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    </AuthenticatedTemplate>
  );
}

export default QBO_Terms;

